<script setup>
import moment from "moment";
import axios from "axios";
import Scheduled from "./inspections/Scheduled.vue";
import Flagged from "./inspections/Flagged.vue";
import {computed, onMounted, ref} from "vue";

const props = defineProps({access: {}, permissions: {}});
const page = ref(1);
const suburbs = ref([]);
const attachments = ref([]);
const tasks = ref(null);
const loading = ref(true);
const zones = ref(null);

const getSuburbsList = () => {
    axios
        .get("/api/dashboard/suburbs")
        .then((response) => {
            suburbs.value = response.data.suburbs;
            attachments.value = response.data.attachments;
        })
        .catch((error) => {
            console.log(error);
        });
};

onMounted(() => {
    axios.get("/api/assign/mine").then((response) => {
        tasks.value = response.data.workTasks;
    });

    getSuburbsList();
    getReports();
});

const getReports = async () => {
    loading.value = true;
    axios
        .get("/api/reporting/show")
        .then((response) => {
            zones.value = response.data.zones;
            loading.value = false;
        })
        .catch((error) => {
            console.log(error);
            loading.value = false;
        });
    ;
};

</script>

<template>
    <div class="flex flex-wrap w-full lg:flex-no-wrap lg:w-3/4 lg:p-4">
        <div class="w-full h-auto bg-white forestree-box all-rounded lg:ml-6">
            <div class="px-1 pb-6 mt-6 bg-white rounded shadow-sm lg:px-8">
                <div
                    class="flex flex-wrap w-full py-4 my-6 border-b lg:flex-no-wrap border-slate-300"
                >
                    <span
                        @click.prevent="page = 1"
                        :class="
                            page === 1
                            ? 'text-blue-700 rounded-lg bg-slate-100'
                            : 'text-slate-500'
                        "
                        class="w-full p-3 mr-0 font-semibold text-center cursor-pointer md:w-auto md:mr-8 hover:text-blue-600"
                    >
            Flagged Trees
                    </span>
                    <span
                        @click.prevent="page = 2"
                        :class="
                            page === 2
                                ? 'text-blue-700 rounded-lg bg-slate-100'
                                : 'text-slate-500'
                            "
                        class="w-full p-3 mr-0 font-semibold text-center cursor-pointer md:w-auto md:mr-8 hover:text-blue-600"
                    >
            Scheduled Inspections
                    </span>
                </div>

                <flagged
                    v-if="page === 1"
                    :access="access"
                    :permissions="permissions"
                    :tasks="tasks"
                    :showPlanting="true"
                />
                <scheduled
                    v-if="page === 2"
                    :suburbs="suburbs"
                    :permissions="permissions"
                    :attachments="attachments"
                    :zones="zones"
                />
            </div>
        </div>
    </div>
</template>

<style scoped>
.table {
    display: flex;
    flex-flow: column nowrap;
    justify-content: space-between;
    font-size: 0.875rem;
    line-height: 1;
}

.table.main-first-cell .tr .td {
    flex-grow: 1;
    flex: none;
    /* text-align: center;
    justify-content: center; */
}

/* .table.main-first-cell .tr .td:first-child {
  flex-grow: 1;
  flex-direction: row;
  display: flex;
  justify-content: start;
} */
.table.striped .tbody .tr:nth-of-type(even) .td {
    background-color: #fff;
}

.table.hovered .tbody .tr:hover .td {
    background-color: #f1f5f8;
}

.table .thead {
    font-weight: 700;
}

.table .thead .tr .td {
    color: #718096;
    text-transform: uppercase;
}

.table .tbody .tr .td {
    background-color: #fff;
}

.table .tr {
    display: flex;
    flex-flow: row nowrap;
    width: 100%;
}

.table .tr .td {
    display: flex;
    flex-flow: row nowrap;
    flex-grow: 1;
    flex-basis: 0;
    word-break: break-word;
    padding: 0.2rem;
    /* margin: 0.25rem; */
}

.status.Low:before {
    background-color: #94e185;
    border-color: #78d965;
    box-shadow: 0px 0px 4px 1px #94e185;
}

.status.Medium:before {
    background-color: #ffc182;
    border-color: #ffb161;
    box-shadow: 0px 0px 4px 1px #ffc182;
}

.status.High:before {
    background-color: #c9404d;
    border-color: #c42c3b;
    box-shadow: 0px 0px 4px 1px #c9404d;
}

.status:before {
    content: " ";
    display: inline-block;
    width: 7px;
    height: 7px;
    margin-right: 10px;
    border: 1px solid #000;
    border-radius: 7px;
}
</style>
